<template>
    <div class="batchExamine" v-loading='loading'>
        <div class="tableBox">
            <el-table
                :data='orderList'
                border
                :header-cell-style="{background:'#f5f7fa'}"
                size="mini"
                :edit-config="{trigger: 'manual', mode: 'row'}"
                >
                <el-table-column
                    v-for="item in columns"
                    :key="item.id"
                    :resizable="true"
                    :prop="item.prop"
                    :min-width="item.width+'px'"
                    :label="item.label"
                    :fixed="item.fixed?true:false"
                    align="center">
                </el-table-column>
            </el-table>
        </div>
        <!-- 财务预审 -->
        <template v-if="userInfo.role_id == 18">
          <div class="writeBox">
              <p class="title">预审：</p>
              <el-radio-group v-model="preAudit.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
          </div>
          <div class="writeBox">
              <p class="title">预审意见：</p>
              <div class="writeItem" style="width:90%">
                  <el-input class="input" type="textarea" maxlength="300" v-model.trim="preAudit.content" placeholder="请输入审核意见" size='mini'></el-input>
              </div>
          </div>
          <div class="buttones">
              <button class="yes" @click="preAuditSubmit">提交</button>
              <button @click="orderCancelClick">取消</button>
          </div>
        </template>
        <template v-else>
          <div class="writeBox">
              <p class="title">审核意见：</p>
              <div class="writeItem" style="width:90%">
                  <el-input class="input" type="textarea" v-model.trim="verify_note" placeholder="请输入审核意见" size='mini'></el-input>
              </div>
          </div>
          <div class="buttones">
              <button class="yes" @click="verifyEvent(1)">审核通过</button>
              <button class="yes" style="background:#d51313;border-color:#d51313;" @click="verifyEvent(0)">审核不通过</button>
              <button @click="orderCancelClick">取消</button>
          </div>
        </template>
    </div>
</template>
<script>
export default {
    props:['edit_ids'],
    data(){
        return{
            orderList:[],
            loading:false,
            verify_note:'',
            userInfo:{},
            columns:[
                {prop:'task_id',label:'任务id',fixed:'left',width:'100',resizable: true},
                {prop:'customer_name',label:'客户全称',fixed:'',width:'100',resizable: true},
                {prop:'month',label:'所属月份',fixed:'',width:'100',resizable: true},
                {prop:'project_name',label:'项目名称',fixed:'',width:'100',resizable: true},
                {prop:'internet_celebrity_name',label:'网红名',fixed:'',width:'100',resizable: true},
                {prop:'internet_celebrity_id',label:'网红id',fixed:'',width:'100',resizable: true},
                {prop:'launch_start_date',label:'投放起始日期',fixed:'',width:'100',resizable: true},
                {prop:'launch_end_date',label:'投放截止日期',fixed:'',width:'100',resizable: true},
                {prop:'created_at',label:'提交修改时间',fixed:'',width:'100',resizable: true},
                {prop:'op_user_name',label:'修改人',fixed:'',width:'100',resizable: true},
                {prop:'op_user_role',label:'修改者角色',fixed:'',width:'100',resizable: true},
                {prop:'op_reason',label:'修改原因',fixed:'',width:'100',resizable: true},
                {prop:'content',label:'修改操作',fixed:'',width:'200',resizable: true},
                {prop:'verify_at',label:'媒介或商务审核时间',fixed:'',width:'160',resizable: true},
                {prop:'verify_status',label:'媒介或商务审核状态',fixed:'',width:'140',resizable: true},
                {prop:'verify_note',label:'媒介或商务审核意见',fixed:'',width:'200',resizable: true},
                {prop:'verify_user_name',label:'媒介或商务审核人',fixed:'',width:'140',resizable: true},
                {prop:'final_verify_at',label:'财务审核时间',fixed:'',width:'160',resizable: true},
                {prop:'final_verify_status',label:'财务审核状态',fixed:'',width:'140',resizable: true},
                {prop:'final_verify_note',label:'财务审核意见',fixed:'',width:'200',resizable: true},
                {prop:'final_verify_user_name',label:'财务审核人',fixed:'',width:'140',resizable: true},
            ],
            preAudit: {//财务预审
              status: '',
              content: ''
            }
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.init()
    },
    methods:{
      /**提交预审 */
      preAuditSubmit(){
        if (this.preAudit.status == '' || !this.preAudit.status) {
          this.$message.warning('请选择预审结果')
          return
        }
        if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
          this.$message.warning('请输入审核意见')
          return
        }
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
            type: 1,
            data_id_list: this.edit_ids,
            status: this.preAudit.status,
            content: this.preAudit.content,
        }).then((res) => {
            var res=res.data;
            if(res&& res.errno == 0){
                this.$emit('emit_refresh')
            }else {
                this.loading = false;
                this.$message({
                    message: res.err,
                    type: 'warning'
                })
            }
        }).catch(()=>{
            this.loading = false;
        })
      },
        verifyEvent(source){
            if(source != 1 && this.verify_note==''){
                this.$message({
                    message: '请输入审核意见',
                    type: 'warning'
                })
                return;
            }
            this.$confirm(source==1?'确定审核通过所审核的订单吗?':(source==0?'确定驳回所审核的订单？':''), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.post(this.URL.BASEURL + this.URL.batchVerify,{
                        edit_ids: this.edit_ids,
                        verify_status: source == 1 ? ((this.userInfo.role_id==13 || this.userInfo.role_id==15) ? 2 : 4) : ((this.userInfo.role_id==13 || this.userInfo.role_id==15) ? 3 : 5),
                        reason: this.verify_note
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.$emit('emit_refresh')
                        }else {
                            this.loading = false;
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.loading = false;
                    })
                }).catch(() => {
            });
        },
        orderCancelClick(){
            this.$emit('cancelToast')
        },
        init(){
            this.loading = true;
            this.$axios.post(this.URL.BASEURL + this.URL.batchVerifyDetail,{
                edit_ids:this.edit_ids
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.orderList = res.rst;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.writeBox{
    margin-top: 10px;
    padding-bottom: 0px;
    .title{
        color: #202652;
        font-size: 15px;
        line-height: 21px;
        font-weight: 500;
        margin-top: 10px;
        display: inline-block;
        width: 80px;
        text-align: right;
    }
    .writeItem{
        display: inline-block;
        width: 33%;
        vertical-align: middle;
        margin-top: 4px;
        font-size: 12px;
        label{
            color: #202652;
            line-height: 20px;
            display: inline-block;
            vertical-align: middle;
        }
        span{
            line-height: 20px;
        }
        &.change{
            label{
                color: red;
            }
            span{
                color: red;
            }
        }
        em{
            padding-left: 6px;
            vertical-align: middle;
        }
        .input{
            width: calc(100% - 200px);
            display: inline-block;
        }
    }
}
.buttones{
    text-align: center;
    margin-top: 30px;
    button{
        width: 91px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #dcdfe5;
        color: #202652;
        font-size: 14px;
        background: transparent;
        margin: 0 4px;
    }
    .yes{
        border-color:#5B7BFE ;
        background: #5B7BFE;
        color: #ffffff;
    }

}
</style>
<style lang="scss">

.batchExamine{
    .thAE{
        background: #E3E9F3 !important;
    }
    .thMedium{
        background: #F6E6E6 !important;
    }
    .thFinance{
        background: #E6F3F3 !important;
    }
    .thTotal{
        background: #eff0f2 !important;
    }
    .thActive{
        color: red !important;
    }
    .el-table{
        font-size: 12px !important;
    }
    .el-date-editor .el-range-separator{
        width: 10%;
    }
    .el-input--suffix .el-input__inner{
        padding-right: 10px !important;
    }
    .el-table th>.cell{
        padding-left:4px !important ;
        padding-right:4px !important ;
    }
    .el-table td, .el-table th{
        padding: 5px 0 !important;
    }
    .numberInput .el-input__inner{
        padding: 0 4px !important;
        text-align: center !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/examine/batchExamine.vue